<template>
  <div class="content">
    <el-row type="flex" justify="start">
      <el-col :span="13">
        <el-form
          label-position="top"
          label-width="200px"
          ref="form"
          :rules="rules"
          :model="form"
        >
          <h3>成长奖励</h3>
          <div>
            <el-row type="flex" justify="center">
              <el-col>
                <h3 class="text-center">VIP1～9等级的Expansion Bonus比例</h3>
              </el-col>
            </el-row>

            <el-table
              :data="form.configs"
              border
              style="width: 100%"
              @cell-mouse-enter="handleCellEnter"
              @cell-mouse-leave="handleCellLeave"
            >
              <el-table-column prop="date" label="VIP等级" width="170">
                <template slot-scope="scope">
                  {{ scope.row.name }}
                </template>
              </el-table-column>
              <el-table-column prop="date" label="奖励比例">
                <template slot-scope="scope">
                  <el-input
                    class="item"
                    type="number"
                    v-model="scope.row.reward_rate"
                    placeholder="请输入1-100正整数"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-col :span="24">
            <h3>成长奖励补充</h3>
            <el-form-item prop="expansion_bonus_reward_rp_rate">
              <el-input
                type="number"
                v-model="form.expansion_bonus_reward_rp_rate"
                placeholder="请输入1-100正整数"
              >
                <template slot="prepend"
                  >成长奖励补充分销奖 = 推荐RP积分 *</template
                >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-row type="flex" justify="center">
              <el-form-item>
                <el-button
                  type="primary"
                  @click="saveConfigs"
                  :loading="btnLoading"
                >
                  保存
                </el-button>
              </el-form-item>
            </el-row>
          </el-col>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      btnLoading: false,
      rules: {
        expansion_bonus_reward_rp_rate: [
          { required: true, message: '请填写', trigger: 'change' },
        ],
      },
      form: {
        expansion_bonus_reward_rp_rate: '',
        configs: [],
      },
    }
  },
  mounted() {
    this.configs()
  },
  methods: {
    /** 鼠标移入cell */
    handleCellEnter(row, column, cell, event) {
      row.isEdit = true
    },
    /** 鼠标移出cell */
    handleCellLeave(row, column, cell, event) {
      row.isEdit = false
    },
    configs() {
      request({
        url: '/api/backend/rewardConfig/expansionBonusConfigs',
        method: 'get',
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.form = {
            ...res.data,
            configs: res.data.configs.map((e) => {
              return {
                ...e,
                reward_rate: parseInt(Number(e.reward_rate * 100)),
              }
            }),
            expansion_bonus_reward_rp_rate: parseInt(
              Number(res.data.expansion_bonus_reward_rp_rate) * 100
            ),
          }
          console.log(this.form)
        }
      })
    },

    saveConfigs() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/rewardConfig/saveExpansionBonusConfigs',
            method: 'post',
            data: {
              expansion_bonus_reward_rp_rate:
                Number(this.form.expansion_bonus_reward_rp_rate) / 100,
              configs: this.form.configs.map((e) => {
                return {
                  ...e,
                  reward_rate: Number(e.reward_rate / 100),
                }
              }),
            },
          })
            .then((response) => {
              this.btnLoading = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
  },
}
</script>

<style>
.content {
  padding: 20px;
}
.text-center {
  text-align: center;
}
</style>
